<script>
export default {
  render(h) {
    return (
      <table class="table text-left table-sm">
        <thead>
          <tr>
            <th scope="col">
              { this.$t('Administration.userList.user') }
            </th>
            <th scope="col">
              { this.$t('Administration.userList.company') }
            </th>
            <th scope="col">
              { this.$t('Administration.userList.contact') }
            </th>
            <th class="text-center" scope="col">
              { this.$t('Administration.userList.vatId') }
            </th>
            <th class="text-center" scope="col">
              { this.$t('Administration.userList.postCount') }
            </th>
            <th scope="col"></th>
          </tr>
        </thead>

        <tbody>
          {this.userList.map(user => 
            <tr>
              <td scope="row">
                <div class="m-0 user-name">
                  { user.name }
                  <br />
                  <router-link
                    class="impersonate-label"
                    to={{name: 'ImpersonateUser', params: { id: user.id }}}>

                    ({ this.$t('Administration.userList.impersonate') })
                  </router-link>
                </div>
              </td>

              <td>
                <div class="company">
                  <p class="company-name m-0">
                    { user.contact.companyName }
                  </p>
                  <p class="contact-names lighter m-0">
                    { user.contact.contactPerson }
                  </p>
                </div>
              </td>

              <td>
                <div class="contact">
                  <a href={`mailto:${user.email}`}>{ user.email }</a>
                  <p class="lighter m-0">
                    { user.contact.phone }
                  </p>
                </div>
              </td>
              <td class="text-center">
                <div class="vat-id">
                  { user.contact.vatId }
                </div>
              </td>
              <td>
                <div class="text-center post-count">
                  { ((user.mediaPlanEvents || {}).info || {}).total }
                </div>
              </td>
              <td class="small-label text-center">
                <router-link to={{name: 'userSettingsId', params: { uuid: user.id }}}>
                  { this.$t('Button.edit') }
                </router-link>
                <br/>
                <br/>
                <router-link to={{name: 'UserList', query: { migrate: user.id }}}>
                  Migriraj
                </router-link>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    )
  },
  props: {
    userList: {
      type: Array,
      required: true,
      default: {}
    }
  }
}
</script>

<style scoped>
table {
  table-layout:fixed;
}
table.table thead tr {
  height: auto;
}
tbody tr {
  height: auto;
}

td {
  max-width: 100px;
  padding: 10px;
}
th {
  word-break: break-word;
  max-width: 100px;
  padding-top: 10px;
  font-weight: bold;
}
.contact-names {
  font-weight: 100;
  margin-bottom: 5px;
}
.company-name {
  margin-bottom: 0px;
}

.lighter {
  color: rgb(129, 129, 129);
  font-weight: lighter;
  font-size: 13px;
}

.impersonate-label {
  font-size: 11px;
  color: #353635A5;
  font-weight: lighter;
  transition: all .3s;
}
.impersonate-label:hover {
  color: #26A6D1;
}

.user-name {
  word-break: break-word;
}
.company {
  word-break: break-word;
}

.contact {
  word-break: break-word;
}

.vat-id {
  word-break: break-word;
}

.small-label {
  font-size: 12px;
}

@media (max-width: 576px) {
  table {
    width: calc(100vw - 30px);
    margin-left: -15px;
  }
}

@media (max-width: 768px) {
  th {
    font-size: 0.6rem;
    padding: 5px;
    padding-left: 0px;
  }
  td {
    font-size: 0.6rem;
    padding: 5px;
    padding-left: 0px;
  }
  .small-label {
    font-size: 0.6rem;
  }
  .impersonate-label {
    font-size: 0.6rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/service/administration/users/UserTable.vue?0337537e